import { yupResolver } from '@hookform/resolvers/yup';
import { parseISO, startOfMonth } from 'date-fns';
import { object, string, StringSchema } from 'yup';

import { formatDay, formatMonth, toDay } from '~/utils/date/date';
import { requiredField } from '~/ui/constants/errorMessages';

export interface IArchivePlanFormValues {
  expirationDate: string;
}

export interface IArchivePlanValidationContext {
  effectiveDate: string | null;
}

export const getEarliestExpirationDate = (effectiveDate: string | null): Date | null => {
  if (!effectiveDate) return null;
  const effectiveMonthStart = startOfMonth(parseISO(effectiveDate));
  return effectiveMonthStart > new Date() ? null : effectiveMonthStart;
};

const earlierThanEffectiveDate = (effectiveDate: string | null): string =>
  `Expiration Date can't be earlier than the Effective Date (${formatMonth(effectiveDate)}).`;

const archivePlanSchema = object().shape({
  expirationDate: string()
    .required(requiredField)
    .test('not-in-future', "Expiration Date can't be in the future.", value => {
      const day = value ? toDay(value) : null;
      return !day || day <= formatDay(new Date());
    })
    .when('$effectiveDate', (effectiveDate: string | null, schema: StringSchema) => {
      const earliest = getEarliestExpirationDate(effectiveDate);
      if (!earliest) return schema;
      return schema.test('not-before-effective', earlierThanEffectiveDate(effectiveDate), value => {
        const day = value ? toDay(value) : null;
        return !day || day >= formatDay(earliest);
      });
    }),
});

export const archivePlanResolver = yupResolver(archivePlanSchema);
